/** Page titles and meta descriptions in English. See `locales/es/meta.ts`. */

export const meta = {
  home: {
    title: 'ILUMETRIA — The Google Analytics for in-person events',
    description:
      'Data intelligence platform that illuminates the ROI of your in-person events with IoT and AI: matchmaking, passive lead capture and direct attribution.',
  },
  contacto: {
    title: 'Contact and demo — ILUMETRIA',
    description:
      'Book an ILUMETRIA demo, request a custom plan or a letter of intent for your next event.',
  },
  panelInversionista: 'Investor traction — ILUMETRIA',
  portero: 'Who has access — ILUMETRIA',
  recuperar: 'Change your password — ILUMETRIA',
  accesoInversionista: 'Investor access — ILUMETRIA',
  demoSensores: 'Product demo — ILUMETRIA',
  accesoDemo: 'Brand panel demo — ILUMETRIA',
  noEncontrada: 'Page not found — ILUMETRIA',
};
